import { createContext } from 'react';
export var RowContext = createContext({});
